/// FILTER TYPES

// date
export const ALL_PERIOD = 'ALL_PERIOD'
export const CUSTOM = 'CUSTOM'
export const ALL_TIME_FROM = 'ALL_TIME_FROM'
export const ALL_TIME_BEFORE = 'ALL_TIME_BEFORE'
export const LAST_YEAR = 'LAST_YEAR'

//role
export const CREW_MEMBER = 'Crew-member'
export const SHKIPER = 'Skipper'
export const CO_SHKIPER = 'Co-skipper'
export const roles = [CREW_MEMBER, SHKIPER, CO_SHKIPER]

// yachts and experience
export const yachtsModels = [
  'Abacus 70',
  'Absolute 50 Fly',
  'Absolute 52',
  'Aqua Yacht 1200',
  'Axopar 24 TT',
  'Aventura 34',
  'Azimut 43 Fly',
  'Amel Supermaramu',
]
export const yachtTypes = [
  'Sailing monohull',
  'Sailing catamaran',
  'Motor yacht',
  'Motor catamaran',
  'Trimaran'
]
export const experiences = [
  'Docking alongside',
  'Plotting',
  'Reading nautical charts',
  'Coastal navigation',
  'Picking up a mooring',
  'Single bow anchor'
]
export const myLicences = [
  'Boat Master Power',
  'Inshore Skipper',
  'Inland Skipper sail'
]
export const charters = [
  {
    id: 1,
    company: 'A Toda Vela Charter',
    dates: '01.01.19 - 16.05.19',
    role: 'Skipper',
    boatType: 'Absolute 52 FLY 2012',
    nm: '102',
    days: '27',
    areas: 'France, French Riviera'
  },
  {
    id: 2,
    company: '12 Knots Yachting Club',
    dates: '21.11.19 - 19.12.19',
    role: 'Crew-member',
    boatType: 'Beneteau Flyer 5.5 2020',
    nm: '78',
    days: '15',
    areas: 'Croatia'
  },
  {
    id: 3,
    company: 'Dream Yacht Charter Croatia',
    dates: '04.05.20 - 16.12.20',
    role: 'Crew-member',
    boatType: 'AGA Marine Spirit 640 2013',
    nm: '89',
    days: '25',
    areas: 'Turkey, Fethiye'
  },
  {
    id: 4,
    company: 'Odysseus Yachting Holidays',
    dates: '09.03.20 - 10.04.20',
    role: 'Skipper',
    boatType: 'Azimut 46 2017',
    nm: '35',
    days: '12',
    areas: 'Turkey, Gocek'
  },
  {
    id: 5,
    company: 'Alaturka Yachting & Travel',
    dates: '11.10.20 - 16.12.20',
    role: 'Skipper',
    boatType: 'Adagio Europa 51.5 2001',
    nm: '44',
    days: '17',
    areas: 'Greece'
  },
]


// notification types
export const SHARE = 'VOYAGE_INVITATION'
export const SUBMIT_EDIT = 'SUBMIT_EDIT'


// logbook filters
export const filters = [
  {
    type: 'date',
    name: 'Даты',
    label: 'dates'
  },
  {
    type: 'crew_role', // for send logbook
    name: 'Роль', // for identification
    label: 'role', // for localization
    width: 160
  },
  {
    type: 'yacht',
    name: 'Яхта',
    label: 'yacht',
    width: 225
  },
  {
    type: 'yacht_type',
    name: 'Тип яхты',
    label: 'yachtType',
    width: 187
  },
  {
    type: 'miles',
    name: 'Мили',
    label: 'miles',
    width: 105
  },
  {
    type: 'tidal',
    name: 'Приливы',
    label: 'tidal',
    width: 90
  },
  {
    type: 'night_hours',
    name: 'Н/ч',
    label: 'nh',
    width: 80
  },
  {
    type: 'marina_start',
    name: 'Марина старта',
    label: 'marinaStart',
    width: 195
  },
  {
    type: 'marina_finish',
    name: 'Марина финиша',
    label: 'marinaFinish',
    width: 195
  },
  {
    type: 'operator',
    name: 'Оператор',
    label: 'operator',
    width: 194
  },
  {
    type: 'route',
    name: 'Маршрут',
    label: 'route',
    width: 225
  },
  {
    type: 'description',
    name: 'Примечания',
    label: 'description',
    width: 223
  },
  {
    type: 'crew_list_file_link',
    label: 'crewList',
    name: 'Крю-лист'
  },
]

export const defaultColumns = [
  {
    type: 'date',
    name: 'Даты',
    label: 'dates'
  },
  {
    type: 'crew_role',
    name: 'Роль',
    label: 'role',
    width: 160
  },
  {
    type: 'yacht',
    name: 'Яхта',
    label: 'yacht',
    width: 225
  },
  {
    type: 'miles',
    name: 'Мили',
    label: 'miles',
    width: 105
  },
  {
    type: 'marina_start',
    name: 'Марина старта',
    label: 'marinaStart',
    width: 185
  },
  {
    type: 'operator',
    name: 'Оператор',
    label: 'operator',
    width: 164
  },
  {
    type: 'description',
    name: 'Примечания',
    label: 'description',
    width: 164
  },
  {
    type: 'crew_list_file_link',
    label: 'crewList',
    name: 'Крю-лист'
  },
]
